window.onload = function() {
// code for sticky add to cart 
jQuery(window).scroll(function(){
 var showw = jQuery('.showw'),
     scroll = jQuery(window).scrollTop();
 if (scroll >= 500) showw.addClass('fixed-cart');
 else showw.removeClass('fixed-cart');
});
};